module.exports = __webpack_public_path__ + "media/images/icon__sectionClosed-79311758fca0b36773191d92d8afc6c7.png";